module.exports = __webpack_public_path__ + "static/media/mastercard-logo.78722bba.png";